import Backbone from 'backbone';
import _ from 'underscore';

let MessageControlModel = Backbone.Model.extend({
  /**
   * @class MessageControlModel
   * @extends Backbone.Model
   * @memberof core.widget.widgetHelpers
   * @classdesc This model create and controls the attribute id
   */
  initialize(config) {
    this.createId();
  },
  /**
   * Set 'id' as unique id
   * @memberOf module:MessageControl
   * @function
   */
  createId() {
    this.set('id', _.uniqueId('msg_'));
  }
});

export default MessageControlModel;



// WEBPACK FOOTER //
// ./lmm-widget/src/widget/widgetHelpers/messageControl/MessageControlModel.js